import _extends from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _classCallCheck from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/**
 * Represents Contact Us.
 * @author kkum
 */import React, { Component, Fragment } from 'react';
import styled from 'styled-components';
import styles from './ContactUs.style';
import { formLabels, formErrorMessages } from '../../../constants/labels/en';
import { sendEmail } from '../../../utils/formUtility';
import analyticsConstants from '../../../constants/analyticsConstants';
import Form from '../Form';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import ReCaptcha from '../../molecules/ReCaptcha';
import { formsCaptchaActions } from '../../../constants/globalConstants';
var ContactUsForm = /*#__PURE__*/function (_Component) {
  _inherits(ContactUsForm, _Component);
  var _super = _createSuper(ContactUsForm);
  function ContactUsForm(props) {
    var _this;
    _classCallCheck(this, ContactUsForm);
    _this = _super.call(this, props);
    _this.submitContactUsForm = _this.submitContactUsForm.bind(_assertThisInitialized(_this));
    _this.successCallback = _this.successCallback.bind(_assertThisInitialized(_this));
    _this.failureCallback = _this.failureCallback.bind(_assertThisInitialized(_this));
    _this.saveCaptchaToken = _this.saveCaptchaToken.bind(_assertThisInitialized(_this));
    _this.state = {
      isSuccessfulSubmission: false,
      errorEmailSending: false,
      isSubmitting: false,
      captchaToken: ''
    };
    return _this;
  }
  _createClass(ContactUsForm, [{
    key: "successCallback",
    value: function successCallback() {
      this.setState({
        isSuccessfulSubmission: true,
        isSubmitting: true
      });
    }
  }, {
    key: "failureCallback",
    value: function failureCallback() {
      this.setState({
        errorEmailSending: true,
        isSubmitting: false
      });
    }
  }, {
    key: "submitContactUsForm",
    value: function submitContactUsForm(values) {
      if (values.ohhoneyname) {
        this.setState({
          errorEmailSending: true
        });
      } else {
        sendEmail(values, this.props.contactUsData.submitUrl, this.state.captchaToken, this.successCallback, this.failureCallback);
      }
    }
  }, {
    key: "saveCaptchaToken",
    value: function saveCaptchaToken(captchaToken) {
      this.setState(function () {
        return {
          captchaToken: captchaToken
        };
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var element = document.getElementById('submit-response');
      if (element) {
        element.scrollIntoView();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var userFormProps = {
        initialValues: {
          customer_email: '',
          name: '',
          phone: '',
          message: ''
        },
        action: this.props.contactUsData.submitUrl,
        method: 'POST',
        acceptCharset: 'UTF-8',
        validationSchema: ['name', 'customer_email', 'phone'],
        handleSubmit: this.submitContactUsForm
      };
      var honepotInputProps = {
        name: 'ohhoneyname',
        type: 'text',
        autocomplete: 'off',
        id: 'ohhoneyname',
        label: formLabels.nvaContactUsForm.NAME,
        ariaLabel: 'Oh Honey Name',
        className: 'input-field-wrapper-oh'
      };
      var userFormNameInputProps = {
        name: 'name',
        type: 'text',
        label: formLabels.contactUsForm.NAME,
        id: 'name',
        ariaLabel: 'Name'
      };
      var userFormEmailProps = {
        type: 'email',
        name: 'customer_email',
        label: formLabels.contactUsForm.EMAIL,
        id: 'customer_email',
        ariaLabel: 'Email'
      };
      var userFormPhoneProps = {
        type: 'text',
        name: 'phone',
        label: formLabels.contactUsForm.PHONE,
        id: 'phone',
        ariaLabel: 'Phone'
      };
      var userFormMessageProps = {
        name: 'message',
        label: formLabels.contactUsForm.PERSONAL_MESSAGE,
        id: 'message',
        ariaLabel: 'Message'
      };
      if (this.state.isSuccessfulSubmission) {
        return __jsx("div", {
          className: "nva-contact-us__form-submit-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h3",
          className: "nva-contact-us__form-success-message success-message"
        }, this.props.contactUsData.successfulSubmissionMessage));
      }
      if (this.state.errorEmailSending) {
        return __jsx("div", {
          className: "nva-contact-us__form-submit-message ".concat(this.props.className),
          id: "submit-response"
        }, __jsx(Heading, {
          HeadingType: "h4",
          className: "nva-contact-us__form-error-message error-message"
        }, formErrorMessages.contactUsForm.EMAIL_SEND_ERROR));
      }
      return __jsx("div", {
        className: "nva-contact-us ".concat(this.props.className)
      }, !this.state.isSuccessfulSubmission || !this.state.errorEmailSending && __jsx(Heading, {
        HeadingType: "h2",
        className: "nva-contact-us__form-heading form-heading"
      }, formLabels.nvaContactUsForm.FORM_HEADING), __jsx(Form, _extends({}, userFormProps, {
        className: "nva-contact-us__form"
      }), __jsx(Fragment, null, __jsx("div", null, __jsx(Form.Input, _extends({}, honepotInputProps, {
        className: "nva-contact-us__form-honepot-input"
      })), __jsx(Form.Input, _extends({}, userFormNameInputProps, {
        className: "nva-contact-us__form-name-input"
      })), __jsx(Form.Input, _extends({}, userFormPhoneProps, {
        className: "nva-contact-us__form-phone-input"
      })), __jsx(Form.Input, _extends({}, userFormEmailProps, {
        className: "nva-contact-us__form-email-input"
      })), __jsx(Form.TextArea, _extends({}, userFormMessageProps, {
        className: "nva-contact-us__form-message-text-area"
      }))), __jsx(Button, {
        styleType: "primary",
        type: "submit",
        className: "nva-contact-us__form-submit-button ".concat(this.state.isSubmitting ? 'btn-success' : 'primary'),
        disabled: this.state.isSubmitting,
        "data-analytics-type": analyticsConstants.contactUs.analyticsType.CONTACT_FORM_TYPE,
        "data-analytics-value": analyticsConstants.contactUs.analyticsValue.CONTACT_FORM_VALUE,
        "data-analytics-variation": ""
      }, formLabels.contactUsForm.SUBMIT_BUTTON), __jsx(ReCaptcha, {
        className: "nva-contact-us__captcha",
        action: formsCaptchaActions.contactForm,
        siteKey: this.props.contactUsData.reCaptchaKey,
        saveToken: this.saveCaptchaToken
      }))));
    }
  }]);
  return ContactUsForm;
}(Component);
ContactUsForm.defaultProps = {
  className: '',
  contactUsData: {}
};
export default styled(ContactUsForm).withConfig({
  componentId: "sc-1imr1lj-0"
})(["", ";"], styles);
export { ContactUsForm as ContactUsFormVanilla };